import { render, staticRenderFns } from "./SubmitArea.vue?vue&type=template&id=090454ba&scoped=true&"
import script from "./SubmitArea.vue?vue&type=script&lang=js&"
export * from "./SubmitArea.vue?vue&type=script&lang=js&"
import style0 from "./SubmitArea.vue?vue&type=style&index=0&id=090454ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090454ba",
  null
  
)

export default component.exports